import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function configurarStoneConnect(empresaId, dados) {
  const url = `${URL}/empresas/${empresaId}/configurar-stone-connect`;
  return () => axios.post(url, dados, SLOW_REQUEST_CONFIG);
}
